import React, { useContext } from 'react';
import { AuthenticationMessage } from './AuthenticationMessage';
import { codes } from '../../../../data/translations';
import { actionTypeEnum } from '../../consts';
import errorCodes from '../../../../data/translations/errorCodes';
import { TranslationContext } from '../../../translations';

export const AuthenticationErrorMessage = (props) => {
	const { authenticationSetActionType, actionType } = props;
	const { translate } = useContext(TranslationContext);

	const handleBackToLogin = () => {
		authenticationSetActionType(actionTypeEnum.LOGIN_FORM);
	};

	const errorsMap = {
		[actionTypeEnum.CAN_NOT_SEND_SMS]: codes.user.cannotFindPhone,
		[actionTypeEnum.PERSONAL_DATA_NOT_FOUND]: codes.user.personalDataNotFound,
		[actionTypeEnum.PIN_CODE_ATTEMPTS_EXCEEDED]: codes.user.pinCodeAttemptsExceeded,
		[actionTypeEnum.SESSION_EXPIRED]: codes.user.sessionExpired,
		[actionTypeEnum.SORRY_AN_ERROR_OCCURRED]: errorCodes.internalError,
		[actionTypeEnum.WRONG_DEEPLINK]: errorCodes.deepLinkNotAvailable,
		[actionTypeEnum.WRONG_LOGIN_USE_ADFS]: codes.user.wrongLoginUseAdfs,
		[actionTypeEnum.WRONG_LOGIN_USE_AZURE_AD]: errorCodes.wrongLogInUseAzureAd,
		[actionTypeEnum.WRONG_PIN_CODE]: codes.user.wrongPinCode,
		[actionTypeEnum.CHECK_CODE_ATTEMPTS_EXCEEDED]: codes.user.authCodeRetriesError,
	};

	return (
		<AuthenticationMessage
			danger
			message={translate(errorsMap[actionType])}
			buttonText={translate(codes.user.backToLoginPage)}
			onButtonClick={handleBackToLogin}
		/>
	);
};
